var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonPinCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#3268C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6375 48.5508C29.0415 48.5508 33.013 47.4253 36.5519 45.1742C40.0908 42.9231 42.8827 39.9558 44.9274 36.2722C42.1749 33.8984 39.0685 32.077 35.6082 30.8082C32.1479 29.5395 28.491 28.9051 24.6375 28.9051C20.784 28.9051 17.1271 29.5395 13.6668 30.8082C10.2065 32.077 7.10016 33.8984 4.34766 36.2722C6.39237 39.9558 9.18419 42.9231 12.7231 45.1742C16.262 47.4253 20.2335 48.5508 24.6375 48.5508ZM24.6375 23.9936C27.2327 23.9936 29.4544 23.0318 31.3025 21.1082C33.1506 19.1845 34.0747 16.8721 34.0747 14.1708C34.0747 11.4695 33.1506 9.15701 31.3025 7.23337C29.4544 5.30972 27.2327 4.3479 24.6375 4.3479C22.0423 4.3479 19.8206 5.30972 17.9725 7.23337C16.1244 9.15701 15.2004 11.4695 15.2004 14.1708C15.2004 16.8721 16.1244 19.1845 17.9725 21.1082C19.8206 23.0318 22.0423 23.9936 24.6375 23.9936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPinCircle);
export default __webpack_public_path__ + "static/media/person_pin_circle.36d3459cea3285dfebfd5a115590a69a.svg";
export { ForwardRef as ReactComponent };